import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Botton, Button } from 'reactstrap';
import './App.css';
import { SystemService } from './Services/SystemService';
import NoSystemCommunication from './Components/NoSystemCommunication';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthService from './Services/AuthService';
import Sidebar from './Components/Sidebar';
import Content from './Components/Content';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import LoginComponent from './Components/LoginComponent';
import ForceChangePassword from './Components/ForceChangePassword';
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { setTranslations, setDefaultLanguage, useTranslation, setLanguage } from 'react-multi-lang';
import { FullscreenProvider, useFullscreen } from './Contexts/FullscreenContext';
import ToastService from './Services/ToastService';
import VersionService from './Services/VersionService';
import ErrorBoundary from './Components/ErrorBoundary';
import UpdateBanner from './Components/UpdateBanner';
import { getLastScreen } from './Utils/screenTracker';
import gr from './Translations/gr.json';
import en from './Translations/en.json';
import mc from './Translations/mc.json';

setTranslations({gr, en, mc});
setDefaultLanguage('gr');

var tick = 0;

const ToastListener = () => {
  const { addToast } = useToasts();

  useEffect(() => {
    return ToastService.onToast((opts) => {
      addToast(opts.message, {
        appearance: opts.appearance || 'info',
        autoDismiss: opts.autoDismiss !== false,
        autoDismissTimeout: opts.autoDismissTimeout || 5000,
      });
    });
  }, [addToast]);

  return null;
};

const AppLayout = ({ user, systemChecker, toggleSidebar, sidebarIsOpen }) => {
  const { isFullscreen } = useFullscreen();

  return (
    <div className={`App wrapper ${isFullscreen ? 'fullscreen-mode' : ''}`}>
      {!isFullscreen && (
        <Sidebar systemChecker={systemChecker} user={user} toggle={toggleSidebar} isOpen={sidebarIsOpen} />
      )}
      <Content systemChecker={systemChecker} user={user} toggleSidebar={toggleSidebar} sidebarIsOpen={sidebarIsOpen} />
    </div>
  );
};

const App = () => {
  const [systemIsLive, setSystemisLive] = useState(false);
  const [communicationErrorMessage, setCommunicationErrorMessage] = useState('');
  const [sidebarIsOpen, setSidebarOpen] = useState(true);
  const [user, setUser] = useState(false);
  const [systemChecker, setSystemChecker] = useState(0);
  const authService = new AuthService();
  const toggleSidebar = () => setSidebarOpen(!sidebarIsOpen);
  const [systemInterval, setSystemInterval] = useState(null);
  const systemService = new SystemService();
  const t = useTranslation();

  const syncUser = () => {
    let u = authService.getUser();
    if(u){
      setUser(u);
    }
    else{
      setUser(false);
    }
  };

  useEffect(() => {
    syncUser();
    authService.refreshUserSession().then(refreshedUser => {
      if (refreshedUser) {
        setUser(refreshedUser);
      }
    });
  }, [systemChecker]);

  useEffect(() => {
    const handleAuthChange = () => syncUser();
    const handleFocusOrVisibility = () => {
      syncUser();
      authService.refreshUserSession().then(refreshedUser => {
        if (refreshedUser) {
          setUser(refreshedUser);
        }
      });
    };

    window.addEventListener('storage', handleAuthChange);
    window.addEventListener('authChanged', handleAuthChange);
    window.addEventListener('focus', handleFocusOrVisibility);
    document.addEventListener('visibilitychange', handleFocusOrVisibility);

    return () => {
      window.removeEventListener('storage', handleAuthChange);
      window.removeEventListener('authChanged', handleAuthChange);
      window.removeEventListener('focus', handleFocusOrVisibility);
      document.removeEventListener('visibilitychange', handleFocusOrVisibility);
    };
  }, []);

  useEffect(() => {
    //if(!systemInterval){
      setSystemInterval(setInterval(() => {
        tick ++;
        setSystemChecker(tick);
      }, 5000));
    //}
  }, []);

  const checkSystemIsLive = () => {

    systemService.checkSystemCommunication().then((r) => {
        setSystemisLive(true);
    }).catch(e => {
      setSystemisLive(false);
      setCommunicationErrorMessage(e);
    })
  };

  useEffect(() => {
    checkSystemIsLive();
  }, []);

  // Global white screen recovery watcher
  useEffect(() => {
    const handleGlobalError = () => {
      setTimeout(() => {
        const root = document.getElementById('root');
        if (!root || !root.firstElementChild || root.innerHTML.trim() === '') {
          const lastScreen = getLastScreen('/');
          console.warn('[GlobalCrashWatcher] Detected empty root / white screen. Reloading last screen:', lastScreen);
          window.location.replace(lastScreen);
        }
      }, 300);
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleGlobalError);
    };
  }, []);

  return (
    <ErrorBoundary>
      <ToastProvider>
        <ToastListener />
        <FullscreenProvider>
          <Container fluid className="p-0">
            <UpdateBanner />
            {
              !systemIsLive && <NoSystemCommunication errorMessage={communicationErrorMessage} checkAgain={checkSystemIsLive} />
            }
            {
              systemIsLive && <Router>
                {
                  user && !user.mustChangePassword && <AppLayout user={user} systemChecker={systemChecker} toggleSidebar={toggleSidebar} sidebarIsOpen={sidebarIsOpen} />
                }
                {
                  user && !!user.mustChangePassword && <ForceChangePassword user={user} onPasswordChanged={(updatedUser) => setUser(updatedUser)} />
                }
                {
                  !user && <LoginComponent></LoginComponent>
                } 
              </Router>
            }
          </Container>
        </FullscreenProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
